import toMap from '~/misc/toMap';

export default toMap([
  'SELECTED_PAYMENT_PLAN',
  'SAVE_ORDER_INFO',
  'SAVE_PAY_INFO',
  'GET_ORDER_INFO',
  'SAVE_ORDER_STATUS',
  'GET_ORDER_STATUS',
  'SET_ORDER_LOADING_STATUS'
]);



// WEBPACK FOOTER //
// ./src/modules/payment/types.js